<div
  [translatable]="{
    transKey: searchPlaceHolderTranslationKey
      ? searchPlaceHolderTranslationKey
      : 'shared.search',
    modEnum: searchPlaceHolderTranslationModule
      ? searchPlaceHolderTranslationModule
      : translationModulesEnum.shared
  }"
  class="search-bar-container mr-2"
>
  <!-- type="text" -->
  <div class="w-100">
    <input
      [placeholder]="
        searchPlaceHolder ? searchPlaceHolder : ('shared.search' | translate)
      "
      [id]="id"
      maxlength="40"
      (keydown.enter)="onEnterKey($event)"
      [(ngModel)]="searchKey"
    />
    <i class="bx bx-search"></i>
  </div>
</div>
